import type { BrowserSupportTier } from '../types/BrowserSupportTypes';

import { FULLY_SUPPORTED_BROWSER_REGEX } from '../regex.autogen';

/**
 * Resolves the browser support tier for the current session.
 *
 * Tier 1 (full): the User-Agent matches the documented "latest N versions"
 * window, encoded as the regex in `regex.autogen.ts` (generated from the
 * `fullySupported` browserslist query at build time).
 * Tier 2 (legacy): anything the regex doesn't match — an out-of-window version
 * or an unrecognized browser. Still functional, so the app loads and shows a
 * persistent banner.
 * Tier 3 (unsupported): obsolete browsers are short-circuited at the CDN before
 * the app loads, so this function does not attempt to detect them.
 */
export function getBrowserSupportTier(
  userAgent: string = navigator.userAgent,
): BrowserSupportTier {
  return FULLY_SUPPORTED_BROWSER_REGEX.test(userAgent) ? 'full' : 'legacy';
}
